import React, { useState } from 'react';
import { userService } from '../services/api';

interface ChangePasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ isOpen, onClose, onSuccess }) => {
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Validações
    if (!senhaAtual.trim()) {
      setError('Senha atual é obrigatória');
      return;
    }

    if (novaSenha.length < 4) {
      setError('Nova senha deve ter pelo menos 4 dígitos');
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setError('Nova senha e confirmação não coincidem');
      return;
    }

    setLoading(true);
    try {
      await userService.changePassword(senhaAtual, novaSenha);
      onSuccess();
      handleClose();
    } catch (err: any) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Erro ao alterar senha. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSenhaAtual('');
    setNovaSenha('');
    setConfirmarSenha('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-key me-2 text-primary"></i>
              Alterar Senha
            </h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {error && (
                <div className="alert alert-danger" role="alert">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}
              
              <div className="mb-3">
                <label htmlFor="senhaAtual" className="form-label fw-bold">
                  <i className="fas fa-lock me-2 text-muted"></i>
                  Senha Atual
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="senhaAtual"
                  value={senhaAtual}
                  onChange={(e) => setSenhaAtual(e.target.value)}
                  placeholder="Digite sua senha atual"
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="novaSenha" className="form-label fw-bold">
                  <i className="fas fa-key me-2 text-primary"></i>
                  Nova Senha
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="novaSenha"
                  value={novaSenha}
                  onChange={(e) => setNovaSenha(e.target.value)}
                  placeholder="Digite a nova senha (mín. 4 dígitos)"
                  minLength={4}
                  required
                />
                <div className="form-text">
                  <i className="fas fa-info-circle me-1"></i>
                  Mínimo de 4 dígitos
                </div>
              </div>
              
              <div className="mb-3">
                <label htmlFor="confirmarSenha" className="form-label fw-bold">
                  <i className="fas fa-check-circle me-2 text-success"></i>
                  Confirmar Nova Senha
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmarSenha"
                  value={confirmarSenha}
                  onChange={(e) => setConfirmarSenha(e.target.value)}
                  placeholder="Repita a nova senha"
                  required
                />
              </div>
            </div>
            
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
                disabled={loading}
              >
                <i className="fas fa-times me-2"></i>
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Alterando...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save me-2"></i>
                    Alterar Senha
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;